import * as React from 'react';
import { SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';

import { utilities } from '~/common';

import { Spinner } from './Spinner';

const { loadScript } = utilities;

declare global {
  interface Window {
    hbspt?: { forms: { create(config: {}): void } };
  }
}
// reference for hubspot form props https://legacydocs.hubspot.com/docs/methods/forms/advanced_form_options
interface HubSpotFormProps {
  submitText?: string;
  portalId: string;
  formId: string;
  style?: React.CSSProperties;
  className?: string;
  formCSS?: string | SerializedStyles;
  onFormSubmitted?: () => void;
}

const FormWrapper = styled.div<{ formCSS?: string | SerializedStyles }>`
  ${({ formCSS }) => formCSS}
`;

// tslint:disable-next-line no-default-export export-name
export class HubSpotForm extends React.Component<HubSpotFormProps, {}> {
  state = {
    loading: true,
  };
  componentDidMount() {
    const { portalId, formId, submitText } = this.props;
    const buttonText = submitText ? { submitText } : { submitText: 'Submit' };
    const script = {
      src: '//js.hsforms.net/forms/v2.js',
      abortLoadIf: () => !!window.hbspt,
    };
    loadScript(script).then(() => {
      this.setState({ loading: false }, () => {
        if (!window.hbspt) return;
        window.hbspt.forms.create({
          portalId,
          formId,
          target: '#hubspot-form',
          submitButtonClass: 'yi-button',
          css: this.props.formCSS,
          onFormSubmitted: () => {
            if (typeof this.props.onFormSubmitted === 'function') {
              this.props.onFormSubmitted();
            }
          },
          translations: {
            en: {
              ...buttonText,
            },
            es: {
              ...buttonText,
            },
          },
        });
      });
    });
  }

  render() {
    const { style, className, formCSS } = this.props;
    const { loading } = this.state;
    return (
      <div style={style}>
        {loading && <Spinner />}
        <FormWrapper className={className} formCSS={formCSS} id="hubspot-form" />
      </div>
    );
  }
}
